import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-challan-list-layout',
  templateUrl: './challan-list-layout.component.html',
  styleUrls: ['./challan-list-layout.component.css']
})
export class ChallanListLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
